/* eslint-disable no-use-before-define */
import React, {useEffect, useState } from 'react';
import useAutocomplete from '@material-ui/lab/useAutocomplete';
import {  useParams } from "react-router-dom";
import { makeStyles } from '@material-ui/core/styles';
import $ from 'jquery';

const useStyles = makeStyles((theme) => ({
  label: {
    display: 'block',
  },
  input: {
    width: 75,
  },
  listbox: {
    width: 75,
    fontSize: 'smaller',
    margin: 0,
    padding: 0,
    zIndex: 1,
    position: 'absolute',
    listStyle: 'none',
    backgroundColor: theme.palette.background.paper,
    overflow: 'auto',
    maxHeight: 200,
    border: '0px',
    '& li':{
      border: '0.5px solid rgba(0,0,0,.25)'
    },
    '& li[data-focus="true"]': {
      backgroundColor: '#4a8df6',
      color: 'white',
      cursor: 'pointer',
    },
    '& li:active': {
      backgroundColor: '#2977f5',
      color: 'white',
    },
  },
}));

export default function HashTagTextInput(props) {
  const classes = useStyles();
  let { postno} = useParams();
  const [input, setInput] = useState('');
  const [optionlist, setOptionList] = useState([]);

  const keyPress=(e)=>{
    if(e.keyCode == 13){
       console.log('value', e.target.value);
    }
 }

  useEffect(()=>{
    $.ajax({
      url:'/binarytext/get-hashtags-list/',
      method: 'GET',
      data: {'post_no': postno, 'direction': props.direction},
      success: function(res){
        setOptionList(res.list)
      },
      error: function(err){
        console.log('error!')
      },
    })
  },[])

  const {
    getRootProps,
    getInputProps,
    getListboxProps,
    getOptionProps,
    groupedOptions,
  } = useAutocomplete({
    id: 'use-autocomplete',
    freeSolo: true,
    onInputChange: (event, value) => {
      props.onChangeFunc(event, value); 
      setInput(value);
    },
    onChange: (event, value) => props.onSelectFunc(event, value),
    onSelect: (event, value) => {console.log("Hi", value)},
    options: optionlist,
    getOptionLabel: (option) => option,
  });

  return (
    <div style={{display: 'inline-block', width:'85px'}}>
      <div {...getRootProps()}>
        <input className={classes.input} onKeyDown={keyPress} {...getInputProps()}/>
      </div>
      {input.length > 2? 
        <ul className={classes.listbox} {...getListboxProps()}>
          {groupedOptions.map((option, index) => (
            <li {...getOptionProps({ option, index })} >{option}</li>
          ))}
        </ul>
       : null}
    </div>
  );
}
